import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillEditor = ({ value, onChange }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [hasUserTyped, setHasUserTyped] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (!value) {
      setDisplayValue(templateContent);
      onChange(templateContent); // make sure parent gets updated too
    } else {
      setDisplayValue(value);
    }
  }, [value]);

  const templateContent = `
    <p>As artificial intelligence continues to evolve, global spending on AI technologies is rapidly climbing past $500 billion each year. This surge is driving a shift in how businesses automate tasks, analyze data, and engage with customers. AI is no longer just a futuristic concept — it's becoming a core strategy in everything from healthcare to finance, reshaping how we interact with the world and make decisions.</p>
    <p>Companies across industries are integrating AI to improve efficiency, uncover insights, and personalize user experiences. From machine learning algorithms to natural language processing tools, AI offers endless possibilities for growth. Read on to discover how AI is transforming digital ecosystems and how your business can harness its power for smarter operations and long-term innovation.</p>
    <h2>You Should Explore AI Technology At Least Once In Your Lifetime And Here's Why.</h2>
    <p>AI isn't just about robots — it's a wide-ranging field that includes predictive analytics, voice recognition, smart assistants, and more. Businesses leverage AI to detect fraud, forecast trends, automate processes, and enhance customer engagement. By understanding its capabilities, companies can stay ahead in an increasingly competitive digital world.</p>
    <p><br></p>
    <blockquote class="ql-align-center">Vivamus cursus lacus ac nisi gravida, sed luctus nisl placerat. Integer porttitor magna id nulla blandit, at scelerisque nisl sodales.</blockquote>
    <p>With AI investment surpassing half a trillion dollars worldwide, its presence is being felt in every major sector. AI tools now power everything from medical diagnoses to personalized product recommendations.</p>
    <ul>
      <li>AI makes intelligence accessible</li>
      <li>Designed to adapt and learn</li>
      <li>Built for the modern enterprise</li>
      <li>Award-winning technology</li>
    </ul>
    <h4>Efficient &amp; Scalable AI Systems.</h4>
    <p>Businesses that adopt AI are seeing measurable benefits—faster operations, deeper insights, and stronger customer engagement. AI is powering everything from chatbots and recommendation engines to fraud detection and predictive analytics. As the technology matures, its impact will continue to expand across sectors and functions, driving innovation and transformation.</p>
    <p>With worldwide annual spend on digital advertising surpassing $325 billion, it's no surprise that different approaches to online marketing are becoming available. One of these new approaches is performance marketing or digital performance marketing. Keep reading to learn all about performance marketing</p>
    <p> AI is not just a tool — it's an evolving ecosystem. With machine learning, computer vision, and natural language processing, companies are building intelligent systems that learn from data and improve over time. These capabilities give businesses a competitive edge in a data-driven world.</p>
    <p>Businesses that adopt AI are seeing measurable benefits—faster operations, deeper insights, and stronger customer engagement. AI is powering everything from chatbots and recommendation engines to fraud detection and predictive analytics. As the technology matures, its impact will continue to expand across sectors and functions, driving innovation and transformation.</p>
  `;

  const handleChange = (content, delta, source, editor) => {
    if (source === 'user') {
      setHasUserTyped(true);
    }
    onChange(content);
  };

  if (!isMounted) {
    return <div>Loading editor...</div>;
  }

  const editorValue = !hasUserTyped && !value ? templateContent : value;

  return (
    <div className="h-[300px] mb-4 quill-editor-wrapper">
      <ReactQuill 
        theme="snow" 
        value={editorValue}
        onChange={handleChange}
        className="h-[250px]"
        modules={{
          toolbar: [
            [{ 'header': [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
          ]
        }}
      />
      <style jsx global>{`
        .quill-editor-wrapper .ql-editor {
          color: ${hasUserTyped || value ? 'inherit' : '#666'};
          font-style: ${hasUserTyped || value ? 'normal' : 'italic'};
        }
        .quill-editor-wrapper .ql-editor p:first-child {
          margin-top: 0;
        }
      `}</style>
    </div>
  );
};

export default QuillEditor;